export default __webpack_public_path__ + "static/media/Award_Statue_Hog.256.faaff29b.png";